module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-Regular.01c9457f.ttf";